export default{props:["view","title","subtitle"],name:"tablink",data:function data(){return{name:"TAB name"}},methods:{setView:function setView(){this.$store.commit("setView",this.view)}},computed:{isCurrent:function isCurrent(){return this.$store.state.view===this.view},compTitle:function compTitle(){return this.title},compSubtitle:function compSubtitle(){return this.subtitle}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/TabLink.vue
// module id = 268
// module chunks = 0